import QuickActionItem from './QuickActionItem'
import styles from './CoachDashboardHome.module.scss'
import { ReactComponent as ProgramsIcon } from '../../../assets/images/common/icons/quickActions/Programs.svg'
import { ReactComponent as EventsIcon } from '../../../assets/images/common/icons/quickActions/Events.svg'
import { ReactComponent as EmailIcon } from '../../../assets/images/common/icons/quickActions/Email.svg'
import { ReactComponent as LandingPageIcon } from '../../../assets/images/common/icons/quickActions/LandingPage.svg'
import { ReactComponent as CoachIcon } from '../../../assets/images/common/icons/quickActions/Coach.svg'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const CoachDashboardQuickActions = ({ communityId }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.quickActionsContainer}>
      <QuickActionItem
        title={t('dashboard.coach.coachDashboardQuickActions.managePrograms')}
        icon={<ProgramsIcon className={styles.icon}/>}
        link='/programs'
      />
      <QuickActionItem
        title={t('dashboard.coach.coachDashboardQuickActions.nineHoleEvents')}
        icon={<EventsIcon className={styles.icon}/>}
        link='/events'
      />
      <QuickActionItem
        title={t('dashboard.coach.coachDashboardQuickActions.landingPage')}
        icon={<LandingPageIcon className={styles.icon}/>}
        externalLink={`${window.location.origin}/landing/${communityId}`}
      />
      <QuickActionItem
        title={t('dashboard.coach.coachDashboardQuickActions.sendAnEmail')}
        icon={<EmailIcon className={styles.icon}/>}
        link='/announcements'
      />
      <QuickActionItem
        title={t('dashboard.coach.coachDashboardQuickActions.coachCommunity')}
        icon={<CoachIcon className={styles.icon}/>}
        externalLink='https://operation-36-network-coaches.mn.co/landing?from=https%3A%2F%2Foperation-36-network-coaches.mn.co%2Ffeed'
      />
    </div>
  )
}

CoachDashboardQuickActions.propTypes = {
  communityId: PropTypes.number,
}

export default CoachDashboardQuickActions
